import { DateTime } from "../../../../components/DateTime/index.js";
import { UserName } from "../../../Users/shared/UserName.js";
import { IdLabel } from "../../../../components/IdLabel/index.js";
import { DownloadPdfButton, EditButton } from "../../../../components/Buttons/index.js";
import { LocationLogEntryFieldsDisplayRenderer } from "./LocationLogEntryFieldsDisplayRenderer.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { humanizeMinutes } from "@therms/web-js";
//#region src/modules/Locations/shared/LocationLogEntries/LocationLogEntry.tsx
function LocationLogEntry({ dateMode = "datetime", entry, onDownloadEntryPDF, onEdit }) {
	if (!entry?.formInput) return null;
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface relative rounded-sm",
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "bg-surface-strong px-sm py-xs rounded-t-sm",
				children: /* @__PURE__ */ jsxs("div", {
					className: "flex flex-wrap justify-between",
					children: [/* @__PURE__ */ jsxs("div", {
						className: "gap-x-xs flex flex-wrap items-baseline",
						children: [
							/* @__PURE__ */ jsx(IdLabel, {
								idLabel: entry.idLabel,
								className: "traking-wide text-color-subtle text-sm font-bold"
							}),
							/* @__PURE__ */ jsx("div", {
								className: "font-bold",
								children: entry.title
							}),
							/* @__PURE__ */ jsx("div", {
								className: "text-color-subtle",
								children: entry.subTitle
							})
						]
					}), /* @__PURE__ */ jsxs("div", {
						className: "gap-x-xs flex flex-wrap justify-between",
						children: [/* @__PURE__ */ jsx("div", {
							className: "text-color-subtle",
							children: /* @__PURE__ */ jsx(UserName, { user: entry.createdByUser })
						}), /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("div", {
							className: "font-medium",
							children: [/* @__PURE__ */ jsx(DateTime, {
								mode: dateMode,
								timestamp: entry.timestamp
							}), entry.timestampEnd && entry.timestamp !== entry.timestampEnd && /* @__PURE__ */ jsxs(Fragment$1, { children: [
								" ",
								"- ",
								/* @__PURE__ */ jsx(DateTime, {
									mode: "time",
									timestamp: entry.timestampEnd
								}),
								!!entry.timeDurationMin && /* @__PURE__ */ jsxs("span", {
									className: "ml-xxs font-light",
									children: [
										"(",
										humanizeMinutes(entry.timeDurationMin),
										")"
									]
								})
							] })]
						}) })]
					})]
				})
			}),
			/* @__PURE__ */ jsx("div", {
				className: "relative",
				children: /* @__PURE__ */ jsx("div", {
					className: "p-sm",
					children: /* @__PURE__ */ jsx(LocationLogEntryFieldsDisplayRenderer, {
						formId: entry.formInput.formId,
						valuesByFieldId: entry.formInput?.fields
					})
				})
			}),
			(!!onEdit || !!onDownloadEntryPDF) && /* @__PURE__ */ jsxs("div", {
				className: "space-x-xs bg-surface-subtle px-sm py-xxs flex items-center justify-end rounded-b-sm",
				children: [!!onDownloadEntryPDF && /* @__PURE__ */ jsx(DownloadPdfButton, {
					size: "sm",
					onClick: onDownloadEntryPDF
				}), !!onEdit && /* @__PURE__ */ jsx(EditButton, {
					size: "sm",
					onClick: () => onEdit(entry.id)
				})]
			})
		]
	});
}
//#endregion
export { LocationLogEntry };

//# sourceMappingURL=LocationLogEntry.js.map